import script from "./CountryFlags.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryFlags.vue?vue&type=script&setup=true&lang=js"

import "./CountryFlags.vue?vue&type=style&index=0&id=50e10501&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e10501"]])

export default __exports__